import React, { useEffect, useState } from "react";
import { database, ref, onValue } from "./firebase";
import "./BillingSystem.css"; 
import { useNavigate } from "react-router-dom";

export default function CustomerView() {
  const [customerPhone, setCustomerPhone] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const invoicesRef = ref(database, "invoices");
    onValue(invoicesRef, (snapshot) => {
      const data = snapshot.val() || {};
      const allInvoices = Object.entries(data).map(([id, val]) => ({
        id,
        ...val,
      }));
      setInvoices(allInvoices);
    });
  }, []);

  useEffect(() => {
    if (submitted && customerPhone) {
      const filtered = invoices.filter(
        (inv) => inv.customerPhone === customerPhone
      );
      setFilteredInvoices(filtered.reverse());
    }
  }, [submitted, customerPhone, invoices]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!customerPhone.match(/^\d{10}$/)) return alert("Enter valid phone number");
    setSubmitted(true);
  };

  return (
    <div className="billing-container">
      <div className="billing-card">
        <h2>📜 Customer Token History</h2>

        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <input
              type="tel"
              maxLength={10}
              placeholder="📱 Enter Your Registered Mobile Number"
              className="billing-input"
              value={customerPhone}
              onChange={(e) => setCustomerPhone(e.target.value)}
            />
            <button className="billing-button primary" type="submit">
              🔍 View My Tokens
            </button>
          </form>
        ) : (
          <>
            <p><strong>Showing tokens for:</strong> {customerPhone}</p>
            {filteredInvoices.length === 0 ? (
              <p>No tokens found.</p>
            ) : (
              filteredInvoices.map((inv) => (
                <div key={inv.id} className="token-card">
                  <strong>Token #{inv.tokenNumber}</strong> - {inv.customerName}
                  <br />
                  <small>{inv.date}</small>
                  <br />
                  <small>
                    <strong>Delivered By:</strong> {inv.deliveredBy || "N/A"}
                  </small>
                  <br />
                  <small>
                    <strong>Payment:</strong> {inv.paymentMethod}
                  </small>
                  <br />
                  <small>
                    <strong>Status:</strong>{" "}
                    <span style={{ color: inv.delivered ? "green" : "orange" }}>
                      {inv.delivered ? "✅ Delivered" : "⏳ Not Delivered"}
                    </span>
                  </small>
                  <ul style={{ marginTop: 10 }}>
                    {inv.items.map((item, idx) => (
                      <li key={idx}>
                        {item.quantity} x {item.product}
                        {item.scheme > 0 ? ` (Scheme: ${item.scheme})` : ""}
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            )}
          </>
        )}
        
      </div>
      <footer className="footer" style={{ marginTop: "40px" }}>
        <p>
           Powered by <strong>Jauhari Web tech</strong>
          <br />
          © 2025 All Rights Reserved.
        </p>
      </footer>
    </div>
  );
}
